// extracted by mini-css-extract-plugin
export default {"container":"EdAeCueTqT0F7gvMpioU","thankYouMsg":"XgYOzsThPCxXUTTXvBze","buyAllMsg":"iYLDgbKAuXwK2T5U5dlA"};